import type { CustomErrorRule } from '@/core/error/transport/types'
import { EndpointsEnum } from '@/services/endpoints'
import { TmAuthVerificationInvalidCodeError } from '@/core/error/transport/auth/TmAuthVerificationInvalidCodeError'

export const signupPhoneVerificationInvalidCodeRule: CustomErrorRule = {
  endpoint: EndpointsEnum.registrationPhoneConfirmCode,
  subCodes: ['user.verification.invalid_code'],
  klass: TmAuthVerificationInvalidCodeError,
}
